$(".carousel-solutions").owlCarousel({
  items: 3,
  margin: 30,
  autoHeight: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: true,
      dots: true,
    },
    600: {
      items: 1,
      nav: true,
      dots: false,
    },
    768: {
      items: 2,
      nav: true,
      dots: true,
    },
    1000: {
      items: 3,
      nav: true,
      dots: true,
    },
  },
  nav: true,
  dots: true,
});

//Mobile Dropdown

$(document).on("click", ".menu-open", function () {
  $(".menu-mobile").toggleClass("hide"),
  $(".menu-open").toggleClass("hide");
  $(".menu-close").toggleClass("hide");
});

$(document).on("click", ".menu-close", function () {
  $(".menu-mobile").toggleClass("hide"),
  $(".menu-close").toggleClass("hide"),
  $(".menu-open").toggleClass("hide");
});

$(".mainHeader .navBar-menuItem--hasChildren").hover(
    function () {
      $(".navBar-subMenu").addClass("show");
      $(this).addClass("dropdownUp");
    },
    function () {
      $(".navBar-subMenu").removeClass("show");
      $(this).removeClass("dropdownUp");
    }
);

// Desktop Dropdown

$(".navBar-menuItem--hasChildren").on("click", function (e) {
  $(".navBar-subMenu").toggleClass("show");

  $(this).toggleClass("dropdownUp");
});

// Solution Card Hover

$("#solution-card .card-body").hover(function (e) {
  e.preventDefault();
  
  $("[data-id=" + $(this).data('id') + "] .card-img-top").toggleClass("hide");
});

$('.show-more-solutions').on('click', function(e) {
  e.preventDefault();

  $(this).closest('.solutions').find('.hidden').removeClass('hidden');
  $(this).addClass('hidden');
})